<template>
  <a class="flex flex-col md:flex-row md:items-center relative block mb-8 p-2 text-start bg-base border-solid border-1 rounded-2 border-base cursor-pointer after:rounded-2 before:rounded-2 hover:shadow-[0_0_20px_-10px] shadow-primary post-item" :href="props.data?.url" :title="props.data?.frontmatter?.title">
    <div class="flex-1 h-full p-4 order-2 md:order-1">
      <div class="relative mb-2 inline-block text-lg font-medium post-item__title">
        <h3 class="post-item__link">{{ props.data?.frontmatter?.title }}</h3>
      </div>
      <PageInfo :page-data="props.data" :hide-views="hideViews"> </PageInfo>
    </div>
    <img class="w-28 h-20 order-1 md:order-2 object-contain" v-if="props.data?.frontmatter?.cover" :src="props.data?.frontmatter?.cover" alt="封面">
  </a>
</template>

<script lang="ts" setup>
import PageInfo from './PageInfo.vue'
import { useCommentConfig } from '../composables/useCommentConfig'
export interface PostItem {
  url?: string
  // 页面的 frontmatter 数据
  frontmatter?: Record<string, any>
  excerpt?: string | undefined
  [key: string]: any
}
const props = withDefaults(defineProps<{data: PostItem}>(), { data: () => ({})  })
const hasViewTypes = new Set(['waline'])
const { type } = useCommentConfig()
const hideViews = !hasViewTypes.has(type.value)
</script>

<style lang="scss">
  .post-item:hover::before,
  .post-item:hover::after {
      width: calc(100% + 4px);
      height: calc(100% + 4px);
  }
  .post-item::before,
  .post-item::after {
    content: '';
    position: absolute;
    z-index: -1;
    width: 0;
    height: 0;
    transition: all .5s ease;
    @apply bg-primary;
  }
  .post-item::before {
    top: -2px;
    left: -2px;   
  }
  .post-item::after {
    bottom: -2px;
    right: -2px;  
  }
</style>
